import SubHeader from "components/common/SubHeader";
import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { createOrder } from "api/payment";
import useUserStore from "@store/useUserStore";
import { useSnackbar } from "contexts/SnackbarContext";

const ExternalPayment = () => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const userInfo = useUserStore((state) => state.userInfo);
    const { showError } = useSnackbar();

    const [isLoading, setIsLoading] = useState(false);

    // 쿼리 파라미터
    const itemName = searchParams.get("item_name") || "";
    const brand = searchParams.get("brand") || "";
    const amount = Number(searchParams.get("amount")) || 0;
    const shipping = Number(searchParams.get("shipping")) || 0;
    const totalAmount = amount + shipping;
    const productType = searchParams.get("product_type") || "LESSON";
    const productId = searchParams.get("product_id");

    const handlePayment = async () => {
        if (isLoading) return;
        setIsLoading(true);

        try {
            const orderParams = {
                product_type: productType,
                // product_id: Number(productId),
                total_amount: totalAmount,
                // quantity: 1,
            };

            const order = await createOrder(orderParams);

            if (order.message === "주문이 생성되었습니다.") {
                const paymentInfo = order.data.payment_params;
                if (!window.innopay) {
                    alert("결제 모듈이 아직 준비되지 않았습니다.");
                    return;
                }
                window.innopay.goPay({
                    ...paymentInfo,
                    buyerEmail: userInfo?.user_email,
                });
            } else {
                showError(order.message || "결제 준비 중 오류가 발생했습니다.");
            }
        } catch (error) {
            showError("결제 처리 중 오류가 발생했습니다.");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="page-payment-info">
            <SubHeader title="결제" />
            <div className="payment-info-wrap">
                <h2 className="title">주문 상품</h2>
                <div className="info-card">
                    <ul>
                        <li>
                            <p>상품명</p>
                            <p>{brand ? `[${brand}] ${itemName}` : itemName}</p>
                        </li>
                    </ul>
                </div>

                <h2 className="title">결제 정보</h2>
                <ul className="price-section">
                    <li>
                        <p className="price-label">상품금액</p>
                        <p className="price-value">
                            {amount.toLocaleString()}원
                        </p>
                    </li>
                    <li>
                        <p className="price-label">배송비</p>
                        <p className="price-value">
                            {shipping > 0
                                ? `${shipping.toLocaleString()}원`
                                : "없음"}
                        </p>
                    </li>
                    <li className="price-total">
                        <p className="price-label">총 결제금액</p>
                        <p className="price-value bold">
                            {totalAmount.toLocaleString()}원
                        </p>
                    </li>
                </ul>
            </div>

            <div className="btn-wrap">
                <button
                    className="btn btn-full btn-large btn-purple500"
                    onClick={handlePayment}
                    disabled={isLoading}
                >
                    {isLoading
                        ? "처리 중..."
                        : `${totalAmount.toLocaleString()}원 결제하기`}
                </button>
            </div>
        </div>
    );
};

export default ExternalPayment;
